import { useState } from 'react'
import PageMainTitle from 'components/commons/PageMainTitle'
import { pageMainTitle } from 'components/topics/TitleGroup/TitleGroup'
import CaseStudy from 'components/home/CaseStudy'
import styles from '../../Topics.module.scss'
import Link from 'next/link'
import { formatCreateDate } from 'lib/functions'
import Pagination from 'components/topics/Pagination'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import EventSlider from 'components/topics/EventSlider'
import Button from 'components/commons/Button/Button'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'
gsap.registerPlugin(ScrollTrigger)

const tweenVars: gsap.TimelineVars = [
  {
    y: 50,
    duration: 1,
    opacity: 0,
    ease: Power4.easeOut,
  },
  {
    y: 100,
    duration: 1.2,
    opacity: 0,
    ease: Power4.easeOut,
  },
  { duration: 0, width: 0, ease: Power4.easeOut, border: '0 #ffff' },
  { duration: 2, width: '100%', border: '0.1px solid #dddddd' },
]

const TopicsAll = ({ posts, page, totalPageNumber, activeEvents }) => {
  const paths = [
    { name: 'TOP', url: '/' },
    { name: 'Topics', url: '/news/page/1/' },
    { name: 'News', url: '#' },
  ]

  const pageId = parseInt(page)
  const currentPage = pageId
  const [totalPages] = useState(totalPageNumber)

  const getPageLink = (pageNo) => {
    return `/news/page/${pageNo}`
  }

  const list = []
  for (let i = 0; i < posts.length; i++) {
    list.push(
      <Link
        href={{ pathname: `/news/${posts[i].id}`, query: { page: currentPage } }}
        as={`/news/${posts[i].id}`}
        key={posts[i].id}
      >
        <a href={`/news/${posts[i].id}`} className={styles.list_wrapper}>
          <div className={styles.list}>
            <span className={styles.day}>{`${formatCreateDate(posts[i].date)}`}</span>
            <p className={styles.topic_title}>{posts[i].title.rendered}</p>
            <span className={styles.topic_arrow}></span>
          </div>
        </a>
      </Link>,
    )
  }

  useEffect(() => {
    if (contents.current) {
      Array.prototype.forEach.call(contents.current.children, (element: HTMLElement, index: number) => {
        timeline
          .from(element.children[0], tweenVars[0], 1 + index * 0.3)
          .fromTo(element.children[1], tweenVars[2], tweenVars[3], 1.2 + index * 0.3)
      })
      timeline.from(button.current, tweenVars[0], 1.5)

      ScrollTrigger.create({
        animation: timeline,
        trigger: contents.current,
        start: 'top-=250 80%',
        toggleActions: 'play none none reverse',
      })
    }
  }, [])

  const timeline = gsap.timeline()
  const contents = useRef<HTMLDivElement>()
  const button = useRef<HTMLDivElement>()

  return (
    <section>
      <PageMainTitle pageMainTitle={pageMainTitle} paths={paths} />
      <EventSlider activeEvents={activeEvents} />
      <div className={styles.content} id="paginationTarget">
        <div className={styles.news_group}>
          <ul className={styles.tab}>
            <li className={styles.currentCategory}>News</li>
            <Link href="/pressrelease/page/1" scroll={false}>
              <li className={styles.category}>
                <a>Press release</a>
              </li>
            </Link>
            <Link href="/events/page/1" scroll={false}>
              <li className={styles.category}>
                <a>Event/Seminar</a>
              </li>
            </Link>
          </ul>
          <div ref={contents}>{list}</div>
          <div className={styles.pagination}>
            <Pagination currentPage={currentPage} totalPages={totalPages} getPageLink={getPageLink} />
          </div>
        </div>
        <div className={styles.mailmagazine_link}>
          <p>
            UI/UXデザイン・システム内製化・DX推進についてのお役立ちメソッドや、限定イベントや最新事例などをお届けします。
          </p>
          <div className={styles.mailmagazine_link_button}>
            <Button text="メールマガジン" href="/mailmagazine" red="red" />
          </div>
        </div>
      </div>
      <CaseStudy tagType="h2" />
      <MailmagazineLink />
    </section>
  )
}

export default TopicsAll
